<template>
    <v-rating
        active-color="amber"
        color="grey-lighten-2"
        empty-icon="mdi-star"
        size="small"
        density="compact"
        readonly
        :model-value="parseInt(hotel.category)"
    />
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class HotelStars extends Vue {
        @Prop({required: true}) hotel
    }

    export default HotelStars
</script>
